import { ColumnSpacer } from "../../../components/common/ColumnSpacer";
import { ModalButton } from "../../../components/ModalButton";
import { Spacer } from "../../../components/common/Spacer";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import React, { useState } from "react";

import {
	StepWrapper,
	StepsActions,
	StepsContent,
	StepsView,
	WizardWrapper,
} from "./styles";

const { Step } = StepsView;

export const WizardSignUp = ({
	onChangeInputs,
	inputs,
	errors,
	info,
	corp,
	onClick,
	loading,
	step,
	setStep,
}) => {
	const [isDisabled, setIsDisabled] = useState(true);

	const steps = [
		{
			key: 0,
			content: (
				<Step1
					setIsDisabled={setIsDisabled}
					onChange={onChangeInputs}
					value={inputs.email}
					errors={errors}
					info={info}
					corp={corp}
				/>
			),
		},
		{
			key: 1,
			content: (
				<Step2
					setIsDisabled={setIsDisabled}
					onChange={onChangeInputs}
					value={inputs}
					errors={errors}
					info={info}
					corp={corp}
				/>
			),
		},
	];
	const nextStep = () => {
		setStep(step + 1);
	};

	const prevStep = () => {
		setStep(step - 1);
	};

	return (
		<>
			<WizardWrapper>
				<StepWrapper>
					<StepsView current={step}>
						{steps.map((item) => (
							<Step key={item.key} />
						))}
					</StepsView>
					<StepsContent>{steps[step].content}</StepsContent>
				</StepWrapper>
			</WizardWrapper>
			<Spacer rows={2} />
			<StepsActions>
				{step > 0 && (
					<ModalButton
						type="secondary"
						label="Regresar"
						onClick={() => prevStep()}
					></ModalButton>
				)}
				<ColumnSpacer column={4} />
				{step < steps.length - 1 && (
					<ModalButton
						disabled={isDisabled}
						label="Continuar"
						type="primary"
						onClick={() => nextStep()}
					></ModalButton>
				)}
				{step === steps.length - 1 && (
					<ModalButton
						disabled={isDisabled}
						loading={loading}
						label="Registrarse"
						type="primary"
						onClick={() => onClick(inputs)}
					></ModalButton>
				)}
			</StepsActions>
		</>
	);
};
